/**
 * Takes an hour and minute and produces a string of the format HH:MM
 * Assumes 00 if hour or minute are not specified
 */

export default function timeToString(hour?: number, minute?: number) {
    return `${(hour ?? 0).toString().padStart(2, '0')}:${(minute ?? 0).toString().padStart(2, '0')}`
}